export type RapidCaptureMetricName =
  | 'camera-first-frame'
  | 'frame-capture'
  | 'capability-check'
  | 'capture-total'
  | 'indexeddb-enqueue'
  | 'shutter-busy'
  | 'item-create'
  | 'analysis';

export const recordRapidCaptureMetric = (
  name: RapidCaptureMetricName,
  value: number,
  metadata: Record<string, number | string | boolean> = {},
) => {
  try {
    if (
      typeof performance !== 'undefined' &&
      typeof performance.mark === 'function'
    ) {
      performance.mark(`rapid-capture:${name}`, {
        detail: { value, ...metadata },
      });
    }
  } catch {
    // Performance mark options are not supported by every browser/test runtime.
  }
  try {
    if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('qkindex:rapid-capture-metric', {
          detail: { name, value, metadata },
        }),
      );
    }
  } catch {
    // Instrumentation must never interrupt capture.
  }
};
